import React, { useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../../../../../../../../components/Spinner';
import { CypressIds } from '../../../../../../../../../../constants/cypressIds';
import { Statuses } from '../../../../../../../../../../constants/statuses';
import { useArchivedRecordDocuments } from '../../../../../../../../../../services/record-service';
import { arrayFilterAndMap } from '../../../../../../../../../../utils/arrayUtil';
import ArchivedModal from '../../../../../../../modals/ArchivedModal';

import { COLUMNS } from './columns';

const ArchivedDocumentsModal = ({ insuredId, recordId, jobId }) => {
  const { data: docs, isLoading: docsLoading } = useArchivedRecordDocuments({ recordId });

  const archivedDocs = useMemo(() => {
    if (docsLoading) {
      return [];
    }

    return arrayFilterAndMap(
      docs,
      d => d.status === Statuses.Archived,
      d => ({ ...d, recordId })
    );
  }, [docs]);

  if (docsLoading) {
    return (
      <Flex
        justifyContent="center"
        position="relative"
      >
        <LoadingSpinner isInline />
      </Flex>
    );
  }

  return (
    <ArchivedModal data={archivedDocs} data-cy={CypressIds.archivedDocumentsSection} tableColumns={COLUMNS} />
  );
};

ArchivedDocumentsModal.propTypes = {
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired
};

export default ArchivedDocumentsModal;
